import runGame from './runGame';
import '../styles.css';

runGame();
